module.exports = __webpack_public_path__ + "img/symphony_588_purple.7ced97c6.jpg";